<div class="mt-4">
    <h2 class="modal-title text-center animated fadeInDown head-font text-secondary-800 h2-bold">
        🐾 Welcome to Our New Website! 🐾
    </h2>
    <h5 class="text-center fw-normal text-secondary-700">
        <br />
        <br />
        We’re excited to announce that our new and improved website is now live!
        <br />
        Shopping for your pet’s favorite food is now easier, faster, and more enjoyable.
        <br />
        Discover a fresh design, smoother browsing, and the same high-quality nutrition your pets love.
        <br />
        We built this site with you—and your furry companions—in mind.
        <br />
        <br />
        Take a look around and see what’s new!
    </h5>
    <div class="form-row-action mt-5 mb-4">
        <button type="button" class="btn btn-primary h5-semibold head-font" (click)="goToShop()">
            Shop Now
        </button>
    </div>
</div>